import { SaveButton } from '@/components/_common';
import EmailSettingsFooterActions from '@/components/Settings/Email/EmailSettingsFooterActions';
import EmailSettingsForm from '@/components/Settings/Email/EmailSettingsForm';
import {
  useMailConfiguration,
  useMailConfigurationCreate,
  useMailConfigurationUpdate,
  useMailConfigurationVerify,
} from '@/core/domain/mail/MailConfigurationController/MailConfigurationController.hooks';
import {
  MailConfigurationCreateRequest,
  MailConfigurationFormValues,
  MailConfigurationUpdateRequest,
  SenderType,
} from '@/core/domain/mail/MailConfigurationController/MailConfigurationController.types';
import { useWindowSize } from '@/hooks';
import { Form, Skeleton, Typography } from 'antd';
const { Title } = Typography;
import { useEffect } from 'react';

const EmailSettingsCrmForm = () => {
  const [form] = Form.useForm<MailConfigurationFormValues>();

  const { width } = useWindowSize();

  const { data, isLoading } = useMailConfiguration({ sender: SenderType.crm });

  const isExistingMail = !!data?.id;

  const updateMutation = useMailConfigurationUpdate();
  const createMutation = useMailConfigurationCreate();
  const mailConfigurationVerify = useMailConfigurationVerify();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const handleSave = async () => {
    const values = await form.validateFields();

    if (data) {
      const obj: MailConfigurationUpdateRequest = {
        ...data,
        ...values,
        sender: SenderType.crm,
      };

      await updateMutation.mutateAsync(obj);
    } else {
      const obj: MailConfigurationCreateRequest = {
        ...values,
        sender: SenderType.crm,
      };

      await createMutation.mutateAsync(obj);
    }
  };

  const handleVerifyEmail = async () => {
    const values = await form.validateFields();

    await mailConfigurationVerify.mutateAsync({
      id: Number(data?.id),
      mail: values?.mail,
      password: values?.password,
      port: values?.port,
      smtp: values?.smtp,
      ssl: values?.ssl,
      tls: values?.tls,
    });
  };

  return (
    <>
      <div className="page-header">
        <Title level={4}>Configurações de E-mail do CRM</Title>

        {width >= 992 && (
          <SaveButton
            loading={updateMutation.isLoading || createMutation.isLoading}
            onClick={handleSave}
          >
            Salvar
          </SaveButton>
        )}
      </div>
      <Skeleton loading={isLoading}>
        <EmailSettingsForm form={form} isExistingMail={isExistingMail} />

        <EmailSettingsFooterActions
          handleSubmit={handleSave}
          saveLoading={updateMutation.isLoading || createMutation.isLoading}
          handleVerifyEmail={handleVerifyEmail}
          verifyEmailLoading={mailConfigurationVerify.isLoading}
        />
      </Skeleton>
    </>
  );
};

export default EmailSettingsCrmForm;
